import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X2AgeCategoryStore} from '../X2AgeCategoryStore';

@observer
export class AddLevelControls extends React.Component<{ store: X2AgeCategoryStore }> {
  render() {
    const {store} = this.props;

    if (store.addLevel === null)
      return null;

    const addLevel = store.addLevel;
    const isPending = addLevel.save?.isPending === true;

    return (<>
      <div className="row justify-content-end">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.completeAdd}
                  disabled={isPending}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.cancel}
                  disabled={isPending}>
            Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Saving" state={addLevel.save} align="right"/>
    </>);
  }
}
